<template>
  <div class="sales-contract-print">
    <div style="width: 210mm; margin: 2mm auto">
      <el-button class="printBtn" type="primary" @click="printHandle">打印</el-button>
    </div>

    <table id="print" class="print-table">
      <thead>
        <tr>
          <td>
            <!-- 这里给页眉占位 -->
            <header class="print-header">
              <img class="company-logo" :src="$tenant.stepIcon">
              <div class="company-standad">GK202412</div>
            </header>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div class="print-area">
              <div class="printItem">
                <div class="title">试用协议</div>
                <section class="contract-info">
                  <div class="flex-justify">
                    <div class="flex-left">
                      合同编号：
                      <span class="display-value">{{agreement.clientContractNo}}</span>
                      <input v-model="agreement.clientContractNo" placeholder="请输入合同编号" class="editable-input">
                    </div>
                    <div class="flex-right">签约地点：杭州市余杭区</div>
                  </div>
                  <div class="font-bold">
                    甲方：
                    <span class="display-value">{{agreement.customerName}}</span>
                    <input v-model="agreement.customerName" placeholder="请输入甲方名称" class="editable-input" style="width:250px">（以下简称：甲方）
                  </div>
                  <div class="font-bold">
                    乙方：
                    <span class="display-value">{{agreement.belongToCustomerNo}}</span>
                    <input v-model="agreement.belongToCustomerNo" placeholder="请输入乙方信息" class="editable-input" style="width:250px">（以下简称：乙方）
                  </div>
                  <div class="agreement-body">
                    <p>乙方同意提供其产品﹙以下简称“样机”﹚给甲方试用，产品清单见下表《试用机型清单》，试用期间双方达成如下协议：</p>
            
                    <div class="section-content">
                      <span class="section-number">1、</span>试用期限为
                      <span class="display-value">{{agreement.trialPeriod}}</span>
                      <input v-model="agreement.trialPeriod" placeholder="请输入试用期限" class="editable-input">天，从
                      <span class="display-value">{{agreement.startDate}}</span>
                      <input v-model="agreement.startDate" placeholder="请输入开始日期" class="editable-input">起至
                      <span class="display-value">{{agreement.endDate}}</span>
                      <input v-model="agreement.endDate" placeholder="请输入结束日期" class="editable-input">为止（该期限包括样机在途时间）。
                    </div>
                    <div class="section-content">
                      <span class="section-number">2、</span>甲方在收到样机后，应仔细阅读随机使用说明书并严格按使用说明书之要求使用样机，甲方样机试用用途仅限于测试，严禁对外销售、出租等。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">3、</span>甲方在使用中若有疑问应及时与乙方联系，乙方应及时予以答复。若甲方出现疑问，不得再擅自继续试用，待乙方书面答复后方可按照乙方答复使用，否则由甲方承担一切损失。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">4、</span>在试用期间若使用效果良好，达到甲方产品要求，则甲方在试用期结束前按双方《试用机型清单》的价格与乙方结清货款。甲方未及时付清货款的，按照日万分之五的标准支付逾期付款利息。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">5、</span>若甲方认为乙方提供的样机不适合甲方产品要求，须在试用期满前将试用品完好的寄还乙方﹙包括外包装、说明书﹑合格证及随机配件﹚，并承担
                      <span class="display-value">{{agreement.transportCost}}</span>
                      <input v-model="agreement.transportCost" placeholder="请输入运输费用" class="editable-input">
                      的运输费。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">6、</span>若甲方使用不当造成样机损坏，则甲方应按价赔偿，若出现试用样机逾期未归还﹑产品原包装破损﹑协议中所列明的附件丢失等造成该产品不能继续销售的情况，应由甲方按本协议中标明的总价购买所试用的样机，并于试用期到期日付清货款。(具体按本合同第四条约定向乙方支付货款和逾期利息)。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">7、</span>试用期满，若有需要继续试用的请于期满前10日提出，经乙方书面同意后方可继续试用。甲方未按期提出的，视为放弃继续试用。因放弃继续使用权又未能及时归还的，视为甲方同意按照本合同所定价款购买样机(具体按本合同第四条约定向乙方支付货款和逾期利息)。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">8、</span>若甲方在试用期限内出现将样机出租或者销售等处分行为的，视为甲方同意购买，乙方有权要求甲方于处分行为发生当日按照本协议中标明的价格支付货款（具体按本合同第四条约定向乙方支付货款和逾期利息）。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">9、</span>因本协议产生的一切纠纷，双方应协商一致，协商不成，均有权协议签订地人民法院提起诉讼。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">10、</span>甲乙双方确认授权以下人员负责收货确认、样品回寄等工作：
                    </div>
            
                    <div class="section-content indent">
                      甲方人员：姓名【
                      <span class="display-value">{{agreement.customerContact}}</span>
                      <input v-model="agreement.customerContact" placeholder="甲方联系人" class="editable-input">
                      】，联系电话：【
                      <span class="display-value">{{agreement.customerPhone}}</span>
                      <input v-model="agreement.customerPhone" placeholder="甲方联系电话" class="phone-input editable-input">】
                      ，签字留档【<span style="padding-right: 80px;"/>】
                    </div>
            
                    <div class="section-content indent">
                      乙方人员：姓名【
                      <span class="display-value">{{agreement.salesPersonName}}</span>
                      <input v-model="agreement.salesPersonName" placeholder="乙方联系人" class="editable-input">
                      】，联系电话：【<span class="display-value">{{agreement.salesPersonPhone}}</span>
                      <input v-model="agreement.salesPersonPhone" placeholder="乙方联系电话" class="phone-input editable-input">
                      】，签字留档【<span style="padding-right: 80px;"/>】
                    </div>
            
                    <div class="section-content indent">
                      备注：若甲方指定人员不在收货现场，甲方其他工作人员的签字也同等有效。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">11、</span>在本协议履行及相关业务合作过程中涉及货款、价格、质量等实质性内容或违约金、赔偿金等涉及乙方经济利益、义务负担的，需乙方确认的文件或/和协议，由乙方加盖公章后生效，否则对乙方不具有约束力。乙方任何部门或个人出具的任何处理意见或允诺，对乙方不具有约束力。
                    </div>
            
                    <div class="section-content">
                      <span class="section-number">12、</span>本协议自双方加盖公章或合同专用章之日起生效，一式贰份，各方各执一份。
                    </div>
                  </div>
          
                  <!-- 试用机型清单表格 -->
                  <div class="section-content">
                    试用机型清单：
                  </div>
                  <table class="contract-item">
                    <thead>
                      <tr>
                        <td width="50">序号</td>
                        <td>名称</td>
                        <td width="100">型号</td>
                        <td width="60">单位</td>
                        <td width="60">数量</td>
                        <td width="80">单价（元）</td>
                        <td width="100">金额（元）</td>
                        <td width="100">备注</td>
                      </tr>
                    </thead>
                    <tr v-for="(item, index) in agreement.materialList" :key="item.id">
                      <td>{{index+1}}</td>
                      <td>
                        <span class="display-value">{{item.sapProductName}}</span>
                        <input v-model="item.sapProductName" placeholder="名称" class="editable-input">
                      </td>
                      <td>
                        <span class="display-value">{{item.manufacturerModel}}</span>
                        <input v-model="item.manufacturerModel" placeholder="型号" class="editable-input">
                      </td>
                      <td>
                        <span class="display-value">{{item.unit}}</span>
                        <input v-model="item.unit" placeholder="单位" class="editable-input">
                      </td>
                      <td>
                        <span class="display-value">{{item.quantity}}</span>
                        <input v-model="item.quantity" placeholder="数量" class="editable-input">
                      </td>
                      <td>
                        <span class="display-value">{{item.unitPrice}}</span>
                        <input v-model="item.unitPrice" placeholder="单价" class="editable-input">
                      </td>
                      <td>{{item.unitPrice * item.quantity}}</td>
                      <td>
                        <span class="display-value">{{item.note}}</span>
                        <input v-model="item.note" placeholder="备注" class="editable-input">
                      </td>
                    </tr>
                  </table>
          
                  <!-- 签字区域 -->
                  <div>（以下为签署页，无正文）</div>
                  <section class="signatures">
                    <div class="sign-item font-bold">
                      <div class="sign-label">
                        甲方：
                        <span class="display-value">{{agreement.customerName}}</span>
                        <input v-model="agreement.customerName" placeholder="请输入甲方名称" class="editable-input" style="width:220px">
                      </div>
                      <div class="sign-line">甲方代表：</div>
                      <div class="sign-date">签约时间：<span style="margin-left: 40px;">年</span><span style="margin-left: 40px;">月</span><span style="margin-left: 40px;">日</span></div>
                    </div>
                    <div class="sign-item font-bold">
                      <div class="sign-label">乙方：新时达工控技术（杭州）有限公司 </div>
                      <div class="sign-line">乙方代表：</div>
                      <div class="sign-date">签约时间：<span style="margin-left: 40px;">年</span><span style="margin-left: 40px;">月</span><span style="margin-left: 40px;">日</span></div>
                    </div>
                  </section>
                </section>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: "TrialAgreementPrint",
    data() {
      return {
        agreement: {
          contractNo: "",
          clientContractNo: "",
          customerName: "",
          belongToCustomerNo: "",
          trialPeriod: "",
          startDate: "",
          endDate: "",
          transportCost: "",
          customerContact: "",
          customerPhone: "",
          salesPersonName: "",
          salesPersonPhone: "",
          materialList: [
            {
              id: 1,
              materialName: "",
              manufacturerModel: "",
              unit: "",
              quantity: "",
              unitPrice: "",
              note: "",
            },
          ],
        },
      };
    },
    mounted() {
      // 如通过 URL 传入 ids，可在此处读取并请求后端数据
      const id = this.$route && this.$route.query && this.$route.query.id;
      if (id) {
        this.fetchData(id);
      }
    },
    methods: {
      fetchData(id) {
        // 示例：根据后端接口调整
        this.$http.get("basic", `clientContracts/${id}`).then((res) => {
          if (res && res.success) {
            Object.assign(this.agreement, res.data || {});
          }
        }).catch(() => {});
      },
      printHandle() {
        document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
        window.print();
        window.location.reload();
      },
    },
  };
</script>

<style lang="scss" scoped>
.print-table {
  width: 210mm;
  margin: 0 auto;
  border-collapse: collapse;
  border: 1px solid #000;
  font-family: 'SimSun', '宋体', serif;
  font-size: 11pt;
  line-height:1.4;
  color: #000;
  background-color: #f0f0f0;
}
.print-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  /* 屏幕展示保持相对布局（非打印时） */
  line-height: 1.8cm;
  padding: 1.5cm 2cm 0;
}
.company-logo { width: 80px; }
.company-standad{
  color: #000;
  font-size: 10pt;
  font-weight: 500;
}
.printItem {
  padding: 0 1.5cm 1.5cm;
  table {
    width: 100%; 
    border: 1px solid #000;
    border-collapse: collapse; 
    margin-bottom: 20px;
    text-align: center;
    thead{
      font-weight: bold;
    }
    tr {
      td {
        border-bottom: 1px solid #000;
        border-right: 1px solid #000;
        padding: 5px;
      }
    }
  }

  
  .flex-justify{
    display: flex;
    justify-content: space-between;
  }
  .font-bold{
    font-weight: bold;
  }

  .title { font-size: 18pt; font-weight: bold; text-align: center; margin-bottom: 10px;}
  .agreement-body {
    margin: 15px 0;
  }
  
  .section-content {
    text-indent: 24px;
  }
  
  .section-number {
    font-weight: bold;
  }
  
  .indent {
    text-indent: 48px;
  }
  .contract-item{
    margin-bottom: 0px;
    thead {
      /* 确保表头在打印多页时重复 */
      display: table-header-group;
    }
  }
  .agreement-content .section-title { font-weight: bold; }
  .agreement-content .section-body { min-height: 200px; border: 1px solid #eee; padding: 10px; }
  .signatures { display: flex; justify-content: space-between; margin-top: 30px; }
  .sign-item { width: 45%; }
  .sign-label { margin-bottom: 10px; }
  .sign-line { margin-bottom: 10px; }
}

/* 输入框样式 */
.editable-input {
  border: none;
  border-bottom: 1px solid #333;
  background: transparent;
  font-size: inherit;
  font-family: inherit;
  color: inherit;
  padding: 2px 4px;
  margin: 0 2px;
  outline: none;
  width: 120px;
}

.phone-input {
  width: 100px;
}

.display-value {
  display: none;
}
/* 打印专用规则 */
@media print {
  .printBtn,.editable-input {
    display: none;
  }
  .display-value {
    display: initial !important;
  }
  .print-table{
    font-size: 11pt;
    border:none;
    background-color: #fff;
  }
  .signatures{
    page-break-inside: avoid;
  }
  .title{
    font-size: 18pt;
  }
  .company-standad{
    font-size: 10pt;
  }
  .print-header{
    padding: 0;
  }
  
  /* 设置页面样式 */
  .print-area, .printItem {
    border: none;
    padding: 0 1px;
  }

  /* 实现打印页码功能 */
  @page {
    margin: 0.5cm 1.5cm 1.5cm; /* 底部边距要足够大以容纳页脚 */
    counter-increment: page;
    @bottom-center{
      font-size: 10pt;
      color: #000;
      content: "第 " counter(page) " 页 共 " counter(pages) " 页";
    }
  }
}

</style>
